var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-404"},[_c('t-error-500',{attrs:{"back-route":{ name: _vm.$routerName.INSTALL_APP }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }